import type { ChartValueTick } from "./chartValueScale";
import { displayLocale } from "./localization";

export function ChartValueGrid({ ticks, left, right, top, bottom }: { ticks: ChartValueTick[]; left: number; right: number; top: number; bottom: number }) {
  return <g aria-hidden="true">
    {ticks.map((tick) => {
      const y = bottom - tick.position * (bottom - top);
      return <line key={tick.value} className="chart-value-grid" x1={left} y1={y} x2={right} y2={y} />;
    })}
    <line className="chart-value-axis" x1={left} y1={top} x2={left} y2={bottom} />
  </g>;
}

export function ChartValueLabels({ ticks, top, bottom, viewBoxHeight, label }: { ticks: ChartValueTick[]; top: number; bottom: number; viewBoxHeight: number; label: string }) {
  const formatter = new Intl.NumberFormat(displayLocale, { maximumFractionDigits: 2 });
  return <div className="chart-value-labels" aria-hidden="true">
    <strong>{label}</strong>
    {ticks.map((tick) => {
      const y = bottom - tick.position * (bottom - top);
      return <span key={tick.value} style={{ top: `${y / viewBoxHeight * 100}%` }}>{formatter.format(tick.value)}</span>;
    })}
  </div>;
}
